import to from "await-to-js";
import { t } from "i18next";
import React, { useContext, useState } from "react";
import { Button } from "../../../../../../components/Button/Button";
import { Input } from "../../../../../../components/Input/Input";
import { Modal } from "../../../../../../components/Modal/Modal";
import { ModalsContext } from "../../../../../../context/modals.context";

import { useNavigate } from "react-router-dom";
import { ExciseLicencesContext } from "../../../../../../modules/obligee/exciseLicences/exciseLicences.context";
import { exciseWarehouseService } from "../../../../../../modules/obligee/exciseWarehouse/exciseWarehouse.service";
import style from "./RenewCancelLicenceModal.module.scss";

interface IRenewCancelLicenceModalProps {}

export const RenewCancelLicenceModal: React.FC<
  IRenewCancelLicenceModalProps
> = () => {
  const { isModalVisible, clearModals } = useContext(ModalsContext);
  const { setError } = useContext(ModalsContext);
  const navigate = useNavigate();
  const { exciseLicences, setExciseLicences, clearPayloadState } = useContext(
    ExciseLicencesContext
  );
  const [note, setNote] = useState("");

  let queryParams = new URLSearchParams(window.location.search);
  const id = queryParams.get("id");

  const postKreiranjeZahtevaZaIzmenuObnovuIliPrekidVazenjaDozvole =
    async () => {
      const dokumentiPayload = exciseLicences.dokumentiZaDozvolu.map(
        (dokument) => {
          return {
            // condition: dokument.condition,
            data: dokument.data,
            dozvolaDocumentType: dokument.dozvolaDocumentType,
            format: dokument.format,
          };
        }
      );
      const payload = {
        note: note,
        tipZahteva: 4,
        zahtev: {
          tipDozvole: exciseLicences.tipDozvole,
          dokumentiZaDozvolu: dokumentiPayload,
          dozvolaInformacije: exciseLicences.dozvolaInformacije,
          skladisteInformacije: {
            ...exciseLicences.skladisteInformacijePayload,
            skladisteId: Number(id),
          },
        },
      };
      const [err, res] = await to(
        exciseWarehouseService.postKreiranjeZahtevaZaIzmenuObnovuIliPrekidVazenjaDozvole(
          payload
        )
      );
      if (err || !res.success) return setError(res?.errorMessage);
      setExciseLicences({ data: res.data });

      navigate("/obveznik/skladista/zahtevUspesan", {
        state: {
          title: t("SKLADISTA.USPESNO_STE_PODNELI_ZAHTEV_ZA_PREKID"),
          redirectPath: "/obveznik/skladista/listaSkladista",
        },
      });

      clearPayloadState();
    };

  const handleCancel = () => {
    clearModals();
  };

  const handleOk = () => {
    postKreiranjeZahtevaZaIzmenuObnovuIliPrekidVazenjaDozvole();
    setNote("");
    clearModals();
  };

  const handleReason = (event: any) => {
    setNote(event.target.value);
  };

  return (
    <Modal
      name="obnovi-prekini-dozvole-modal"
      title={t(
        "SKLADISTA.UNESITE_RAZLOG_ZA_PRESTANAK_VAZENJA_DOZVOLE_SERIJSKI_BR"
      )}
      footer={null}
      onCancel={handleCancel}
      open={isModalVisible("renewCancel")}
    >
      <div className={style.mainContainer}>
        <div>
          <div className="pb-20">
            <Input
              onChange={handleReason}
              value={note}
              name="razlog-prekida-dozvole"
            />
          </div>
          <div className="alignRight">
            <Button type="primary" onClick={handleOk}>
              {t("SKLADISTA.POSALJI_ZAHTEV")}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
